import { render, staticRenderFns } from "./examStatisticsWx.vue?vue&type=template&id=fd3cbd5e&scoped=true&"
import script from "./examStatisticsWx.vue?vue&type=script&lang=js&"
export * from "./examStatisticsWx.vue?vue&type=script&lang=js&"
import style0 from "./examStatisticsWx.vue?vue&type=style&index=0&id=fd3cbd5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3cbd5e",
  null
  
)

export default component.exports